import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Domain } from '../models/domain.model';
import { RequestStatus } from '../../enums/request-status.enum';

export interface DomainsState extends EntityState<Domain> {
  currentDomainId: string | null;
  status: RequestStatus;
  error: string | null;
}

export const domainsAdapter: EntityAdapter<Domain> = createEntityAdapter<Domain>({
  selectId: (domain: Domain) => domain.uuid,
  sortComparer: (left: Domain, right: Domain) => left.name.localeCompare(right.name),
});

export const initialDomainsState: DomainsState = domainsAdapter.getInitialState({
  currentDomainId: null,
  status: RequestStatus.Idle,
  error: null,
});

